<script lang="ts" setup>
interface Props {
  hideSpreads?: boolean
}

withDefaults(defineProps<Props>(), {
  hideSpreads: false
})
</script>

<template>
  <div v-if="hideSpreads" class="block w-full p-2 text-center sr-topper">
    <div class="grid grid-cols-3">
      <div class="flex justify-start items-center">
        <div class="2xl:hidden">
        </div>
      </div>
      <div class="flex justify-center font-bold fs-symbol items-center">
        <slot name="symbol"></slot>
      </div>
      <div v-if="hideSpreads" class="2xl:flex 2xl:col-span-1 items-center gap-0 ml-auto">
        <slot name="end"></slot>
      </div>
    </div>
  </div>

  <div v-else class="hidden lg:block w-full p-2 text-center sr-topper">
    <div class="grid grid-cols-3">
      <div class="flex justify-start items-center">
        <div class="2xl:hidden">
          <slot name="start"></slot>
        </div>
      </div>
      <div class="flex justify-center font-bold fs-symbol items-center">
        <slot name="symbol"></slot>
      </div>
      <div class="2xl:hidden flex justify-end items-center">
        <slot name="end"></slot>
      </div>
    </div>
  </div>
  <header v-if="!hideSpreads" class="sr-navbar-root grid grid-cols-1 rounded-none p-2">
    <!-- Десктопная версия шапки -->
    <div class="w-full hidden lg:grid lg:grid-cols-4 items-center">

      <!--  Заглушка для отступа -->
      <div class="hidden 2xl:flex lg:col-span-1">
        <slot name="start"></slot>
      </div>

      <div class="col-span-4 2xl:col-span-2">
        <!-- Блок с торговой парой -->
        <!-- <div class="hidden lg:grid lg:grid-cols-3">
          <div class="flex justify-start items-center">
            <div class="2xl:hidden">
              <slot name="start"></slot>
            </div>
          </div>
          <div class="flex justify-center items-center">
            <slot name="symbol"></slot>
          </div>
          <div class="flex justify-end sr-navbar-end items-center 2xl:hidden">
            <slot name="end"></slot>
          </div>
        </div> -->

        <!-- Блок с информацией -->
        <div class="lg:grid lg:grid-cols-3">

          <!-- Покупка -->
          <div class="sr-eye-ex justify-start flex items-center">
            <!-- <span class="pit"> -->
            <slot name="exBuy"></slot>
            <!-- </span> -->
          </div>

          <!-- Спред -->
          <div class="sr-spread text-center justify-center flex items-center">
            <span class="pit">
              <slot name="spread"></slot>
            </span>
          </div>

          <!-- Продажа -->
          <div class="sr-eye-ex justify-end flex items-center">
            <!-- <span class="pit"> -->
            <slot name="exSell"></slot>
            <!-- </span> -->
          </div>

        </div>
      </div>

      <!-- Блок инструментов -->
      <div class="hidden 2xl:flex 2xl:col-span-1 items-center gap-0 ml-auto">
        <slot name="end"></slot>
      </div>

    </div>
    <!-- Мобильная версия шапки -->
    <div class="w-full sr-navbar-mobile grid grid-cols-2 lg:hidden items-between">
      <!-- Торговая пара -->
      <div class="col-span-1">
        <slot name="symbol"></slot>
      </div>
      <!-- Спред -->
      <div class="col-span-1 flex justify-end mb-2">
        <slot name="spread"></slot>
      </div>
      <!-- Биржа покупки -->
      <div class="col-span-1">
        <slot name="exBuy"></slot>
      </div>
      <!-- Биржа продажи -->
      <div class="col-span-1 flex justify-end">
        <slot name="exSell"></slot>
      </div>
      <!-- Блок инструментов -->
      <div class="mt-2 col-span-2 flex items-center justify-center gap-3 xs-buttons">
        <slot name="end"></slot>
      </div>
      <!-- Блок "слева" -->
      <div class="mt-2 col-span-full text-center">
        <slot name="start"></slot>
      </div>

    </div>
  </header>
</template>
